<template>
  <div v-if="$route.name !== 'AccountDetails'" class="unlock-ai-visibility">
    <p class="title">
      {{ $t('unlock-ai-visibility') }}
    </p>
    <p class="desc" v-html="$t('unlock-ai-visibility-info')" />
    <kw-button
      :button-text="$t('sign-up-ai-visibility')"
      :button-classes="'rankscale'"
      button-type="primary"
      @click="signUpForAiVisibility"
      :buttonDisabled="buttonDisabled"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isAiPackage } from '~/views/auth/billing-utils';

export default {
  name: 'UnlockAiVisibility',
  props: {
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.fetchPackages();

    if (this.getIsAiVisibilityDomainsFetching) {
      this.setIsAiVisibilityDomainsFetching(false);
    }
  },
  computed: {
    ...mapGetters(['getIsAiVisibilityDomainsFetching', 'getUserData', 'getPackages']),
  },
  methods: {
    ...mapActions(['setIsAiVisibilityDomainsFetching', 'fetchPackages']),
    signUpForAiVisibility() {
      if (Math.random() >= 0 || Array.isArray(this.getUserData._original.default_card)) {
        const aiPackage = this.getPackages.find(isAiPackage);
        if (aiPackage) {
          this.$router.push({
            name: 'AccountDetails',
            query: { id: aiPackage.package_identity },
          });
        }
      } else {
        this.$emit('openSubscribeModal');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.unlock-ai-visibility {
  width: 100%;
  padding: 0 23px;
  p {
    font-family: Roboto;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0%;

    &.title {
      font-weight: 700;
      margin: 18px 0;
    }
    &.desc {
      margin: 0 0 24px;
      ::v-deep .link {
        font-weight: 700;
        color: kw-color(kw-purple, 10);
      }
    }
  }
  & > button.kw-button.kw-btn-primary {
    height: 44px;
  }
}
</style>
